import React from 'react';
import { createRoot } from 'react-dom/client';
// import Login from '../components/login';
import LoginPage from '../components/LoginPage/LoginPage';
// import registerServiceWorker from '../registerServiceWorker';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<LoginPage />);

// registerServiceWorker();